import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useSimpleLineCardStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXL),
        marginBottom: tokens.spacingVerticalL,

        '&:first-child': {
            marginTop: tokens.spacingVerticalL
        },

        '@media screen and (max-width: 1200px)': {
            flexDirection: 'column'
        }
    },
    lineInfoContainer: {
        display: 'flex',
        flexShrink: '0',
        width: '350px',
        maxWidth: '350px',
        ...shorthands.padding(tokens.spacingVerticalM),

        '& img': {
            maxWidth: '100px',
            maxHeight: '100px',
            marginRight: '1.75rem'
        },

        '@media screen and (max-width: 480px)': {
            width: '100%',
            maxWidth: '100%'
        }
    },
    lineNumber: {
        fontSize: tokens.fontSizeHero700,
        lineHeight: '2.125rem',
        fontWeight: tokens.fontWeightBold,
        marginBottom: tokens.spacingVerticalL
    },
    lineName: {
        fontSize: tokens.fontSizeBase400,
        lineHeight: tokens.lineHeightBase300,
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: '.3125rem'
    },
    lineDevice: {
        fontSize: tokens.fontSizeBase400,
        lineHeight: tokens.lineHeightBase300,
        marginBottom: '.3125rem'
    },
    linePlan: {
        fontSize: tokens.fontSizeBase400,
        lineHeight: tokens.lineHeightBase300,
        fontWeight: tokens.fontWeightSemibold
    }
});

export default useSimpleLineCardStyles;
